import { Fade } from 'react-reveal';
import Zoom from 'react-reveal/Zoom';
import ImageSlider from "../../components/ImageSlider";

import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const OverviewSlider = () => {
  return (
    <div className="overview-slider">
      <Fade left >
        <div className="sub-title">Created with</div>
      </Fade>
      <Fade right >
        <div className="title">experience</div>
      </Fade>
      <Zoom>
        <div className="slider">
          <ImageSlider slides={CONSTANTS.overviewSliderContent} />
        </div>
      </Zoom>
    </div>
  );
};
export default OverviewSlider;
